import React, { Component } from "react";
import Headers from "../Layouts/HeaderReceptionist";
import axios from "axios";
import $ from "jquery";

export class NextOfKin extends Component {
  constructor(props) {
    super(props);

   

    const url = "";

    this.state = {
      nextofkinname: "",
      nextofkinProfession: "",
      nextofkinEducation: "",
      nextofkinNationality: "",
      nextofkinTel: "",
      patientid: "",
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    //this.PrintWindow = this.PrintWindow.bind(this);
  }

  componentDidMount() {
    this.setState({
      patientid: localStorage.getItem("patientId"),
      // pateintDetails : (Math.random() + 1).toString(36).substring(7)
    });
    console.log(this.state);
  }

  handleChange(event) {
    this.setState({ [event.target.name]: event.target.value });
  }

  handleSubmit = (event) => {
    const headers = {
      "Content-Type": "application/json",
      token: localStorage.getItem("accessToken"),
      patientid: localStorage.getItem("patientId"),
    };
    event.preventDefault();
    console.log(headers);
    axios
      .post(
        this.api_url+"reception/registerpatient/nextofkin",
        this.state,
        { headers: headers }
      )
      .then((response) => {
        console.log(response);

        if (response.data["status"] == "patient next of kin updated") {
          $(".alert-success").show();
          setTimeout(function (props) {
            window.location.href = "/search/patient";
            // this.props.history.push('/reception/dashboard')
          }, 2000);
        }
      })
      .catch((error) => {
        console.log(error);
        $('#SubmitError').show();
        $(".alert-success").hide();
      });
  };

  render() {
    const font16 = { fontSize: "16px" };
    const fontFamilyNunito = { fontFamily: "Nunito, sans-serif" };
    const floatRight = { float: "right;" };
    const floatLeft = { float: "left;" };
    const displayHidden = { display: "none" };

    const {
      nextofkinname,
      nextofkinProfession,
      nextofkinEducation,
      nextofkinNationality,
      nextofkinTel,
    } = this.state;
    return (
      <div>
        <Headers />
        <main>
          <h2 className="text-center">Next Of Kin</h2>
          <div className="container p-2">
            <form onSubmit={this.handleSubmit}>
              <div className="form-row pt-4">
                <div className="col-md-4 text-lg-center font-weight-bold p-1">
                  <p className="text-capitalize" style={font16}>
                    Spouse / Guardian
                  </p>
                </div>
                <div className="col-md-4 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize " style={fontFamilyNunito}>
                      Name
                    </h6>
                    <input
                      className="form-control"
                      onChange={this.handleChange}
                      value={nextofkinname}
                      name="nextofkinname"
                      type="text"
                      required
                    />
                  </div>
                  <div className="py-1">
                    <h6 className="text-capitalize">Profession</h6>
                    <input
                      className="form-control"
                      onChange={this.handleChange}
                      value={nextofkinProfession}
                      name="nextofkinProfession"
                      type="text"
                      required
                    />
                  </div>
                </div>
                <div className="col-md-4 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize">Nationality</h6>
                    <input
                      className="form-control"
                      onChange={this.handleChange}
                      value={nextofkinNationality}
                      name="nextofkinNationality"
                      type="text"
                      required
                    />
                  </div>
                </div>
              </div>
              <div className="form-row pt-4">
                <div className="col-md-4 text-lg-center font-weight-bold p-1">
                  <p className="text-capitalize" style={font16}>
                    Contact Information
                  </p>
                </div>
                <div className="col-md-4 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize " style={fontFamilyNunito}>
                      Phone Number
                    </h6>
                    <input
                      className="form-control"
                      onChange={this.handleChange}
                      value={nextofkinTel}
                      name="nextofkinTel"
                      type="text"
                    />
                  </div>
                </div>
              </div>
              <div className="form-row pt-4">
                <div className="col-md-4 text-lg-center font-weight-bold p-1">
                  <p className="text-capitalize" style={font16}>
                    Education
                  </p>
                </div>
                <div className="col-md-4 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize " style={fontFamilyNunito}>
                      Education
                    </h6>
                    <input
                      className="form-control"
                      onChange={this.handleChange}
                      value={nextofkinEducation}
                      name="nextofkinEducation"
                      type="text"
                    />
                  </div>
                </div>
              </div>

              <div
                id="loginSuccess"
                className="alert alert-success"
                style={displayHidden}
                role="alert"
              >
                <strong>Success! </strong>Patient Next Of Kin Entered
                Successful.
              </div>

              <div className="row">
                {/* <div style={displayHidden} className="col col-6"><button className="btn btn-primary btn-warning rounded-pill px-4 font-weight-bold" type="button" style={floatRight}>Send To Triage</button></div> */}
                <div className="col col-6">
                  <button
                    className="btn btn-primary btn-warning rounded-pill px-5 font-weight-bold"
                    type="submit"
                  >
                    Submit
                  </button>
                </div>
              </div>
            </form>
          </div>
        </main>
      </div>
    );
  }
}

export default NextOfKin;
